module.exports = __webpack_public_path__ + "static/media/group_copy_2@2x.b363af28.jpg";